import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'
import { useSetTrue } from '../../../../hooks'
import { findInArr } from '../../../../utils'

import S from './Video.styled'

const Video = ({
  localData,
  sbData,
  isPlaying,
  i,
  imgElement: GatsbyImg,
  playerClassName = 'video-player',
  playerLoop = true,
  playerWidth = '100%',
  playerHeight = '100%',
  playerVolume = 0,
  playerMuted = true,
  playsinline = true,
}) => {
  const { isTrue, setTrue } = useSetTrue()
  const playing = isPlaying[i] || false

  const sbVideo = sbData && sbData.video
  const sbVideoData = sbVideo && findInArr(sbVideo, 'component', 'video')
  const sbVideoFile = sbVideoData && sbVideoData.file

  const sbThumbnail = sbData && sbData.thumbnail
  const sbThumbnailData =
    sbVideo && findInArr(sbThumbnail, 'component', 'image')
  const sbThumbnailFile = sbThumbnailData && sbThumbnail.file

  const localVideoData = localData && localData.src
  const localThumbnailData = localData && localData.thumbnail

  const videoSrc = sbVideoFile ? sbVideoFile.filename : localVideoData

  const thumbnailSrc = sbThumbnailFile
    ? sbThumbnailFile.filename
    : localThumbnailData.src
  const thumbnailAlt = sbThumbnailFile
    ? sbThumbnailFile.alt
    : localThumbnailData.alt

  const playerSettings = {
    className: playerClassName,
    url: videoSrc,
    playing: playing,
    loop: playerLoop,
    width: playerWidth,
    height: playerHeight,
    volume: playerVolume,
    muted: playerMuted,
    playsinline: playsinline,
  }

  return (
    <S.Video>
      <div className="video-container">
        {!isTrue && GatsbyImg ? (
          <GatsbyImg />
        ) : (
          <img
            src={thumbnailSrc}
            alt={thumbnailAlt}
            className="thumbnail"
            style={{ position: `absolute` }}
          />
        )}
        <ReactPlayer {...playerSettings} onReady={() => setTrue()} />
      </div>
    </S.Video>
  )
}

Video.propTypes = {
  isPlaying: PropTypes.object,
  i: PropTypes.number,
  playerClassName: PropTypes.string,
  playerLoop: PropTypes.bool,
  playerWidth: PropTypes.string,
  playerHeight: PropTypes.string,
  playerVolume: PropTypes.number,
  playerMuted: PropTypes.bool,
  playsinline: PropTypes.bool,
}

export default Video
